module.exports = __webpack_public_path__ + "img/iguana-tatuada-1390.f3710059.webp";